import { Link } from "react-router-dom";
import { PageMeta } from "@/components/common/PageMeta";
import { Badge } from "@/components/common/Badge";
interface PlaceholderPageProps {
  badge: string;
  title: string;
  description: string;
  path: string;
  metaTitle: string;
}

export function PlaceholderPage({ badge, title, description, path, metaTitle }: PlaceholderPageProps) {
  const sectionBg = "rgba(var(--color-overlay-rgb),0.75)";

  return (
    <>
      <PageMeta
        title={metaTitle}
        description={description}
        path={path}
      />

      <main className="relative z-10 min-h-screen pt-[var(--topnav-height)]">
        <div
          className="backdrop-blur-[2px] min-h-[calc(100vh-var(--topnav-height))] flex flex-col"
          style={{ background: sectionBg }}
        >
          <div className="flex-1 flex flex-col items-center justify-center px-8 pb-20 max-w-6xl mx-auto w-full">
            <Badge className="mb-8">{badge}</Badge>
            <h1 className="text-3xl md:text-5xl font-light tracking-tight mb-4 font-[family-name:var(--font-display)] text-center">
              {title}
            </h1>
            <p className="text-lg text-[var(--color-fg-secondary)] max-w-md font-light text-center mb-10">
              {description}
            </p>
            <Link
              to="/"
              className="text-sm font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] transition-colors"
            >
              &larr; Back to home
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
